import { render, staticRenderFns } from "./AffiliatesCard.vue?vue&type=template&id=0561921c&"
import script from "./AffiliatesCard.vue?vue&type=script&lang=js&"
export * from "./AffiliatesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports